export default class SettingDto {
    constructor(obj) {
        this.login = obj.login
        this.parameter = obj.parameter
        this.value = obj.value
        this.updateDate = obj.updateDate
    }
}